export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/modal-share-public-url/hooks/useModalSharePublicURL.ts"